var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccion02Editar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#101010",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.11 15.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m8.3,3.09L1.57,9.81c-.07.08-.13.17-.17.27L.04,14.2c-.08.25-.02.52.17.7.13.13.31.2.49.2.07,0,.15-.01.22-.04l4.12-1.37c.1-.03.19-.09.27-.17l6.73-6.73-3.72-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m14.71,2.18l-1.78-1.78c-.53-.54-1.41-.54-1.94,0l-1.72,1.72,3.72,3.72,1.72-1.72c.26-.26.4-.6.4-.97s-.14-.71-.4-.97Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccion02Editar);
export default __webpack_public_path__ + "static/media/accion02-editar.bfedbc3b753a003505701a007983b530.svg";
export { ForwardRef as ReactComponent };